import { Skeleton } from '~/shared/ui/SkeletonList'

export function LoadingBlock() {
  return (
    <>
      <Skeleton animated $height={66} style={{ marginBottom: '4px' }} />
      <Skeleton animated $height={21} style={{ marginBottom: '20px' }} />
      <Skeleton animated $height={68} style={{ marginBottom: '20px' }} />
      <Skeleton animated $height={24} style={{ marginBottom: '16px' }} />

      <Skeleton animated $height={719} style={{ marginBottom: '8px' }} />
    </>
  )
}
